import { render, staticRenderFns } from "./project_share.vue?vue&type=template&id=687d68fe&scoped=true"
import script from "./project_share.vue?vue&type=script&lang=js"
export * from "./project_share.vue?vue&type=script&lang=js"
import style0 from "./project_share.vue?vue&type=style&index=0&id=687d68fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687d68fe",
  null
  
)

export default component.exports